import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const mode = properties.mode || 'manual';

  if (mode === 'manual') {
    const fields = properties.fields?.values;

    if (!fields || fields.length === 0) {
      errors.push({
        key: 'fields',
        message: 'At least one field operation is required',
      });
    } else {
      fields.forEach((field: any, idx: number) => {
        if (!field.name || field.name.trim() === '') {
          errors.push({
            key: `fields.values[${idx}].name`,
            message: 'Field name is required',
          });
        }

        // Rename and copy require newName
        if (['rename', 'copy'].includes(field.operation)) {
          if (!field.newName || field.newName.trim() === '') {
            errors.push({
              key: `fields.values[${idx}].newName`,
              message: 'New field name is required for this operation',
            });
          }
        }

        // Convert requires toType
        if (field.operation === 'convert') {
          if (!field.toType) {
            errors.push({
              key: `fields.values[${idx}].toType`,
              message: 'Target type is required for conversion',
            });
          }
        }
      });
    }
  } else if (mode === 'json') {
    if (!properties.jsonData || properties.jsonData.trim() === '' || properties.jsonData === '{}') {
      errors.push({
        key: 'jsonData',
        message: 'JSON output definition is required',
      });
    } else {
      try {
        JSON.parse(properties.jsonData);
      } catch {
        errors.push({
          key: 'jsonData',
          message: 'Invalid JSON format',
        });
      }
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
